import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-body" }
const _hoisted_2 = { class: "mb-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label"
}, "Name", -1)
const _hoisted_4 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_5 = { class: "input-group mb-5" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text",
    for: "inputGroupSelect01"
  }, "Prompt Type")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: "0"
}, "Choose...", -1)
const _hoisted_8 = ["value"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "input-group mb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "input-group-text",
    id: "basic-addon1"
  }, "Separator")
], -1)
const _hoisted_12 = { class: "mx-5" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "input-group mb-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "input-group-text",
    id: "basic-addon1"
  }, "Separator")
], -1)
const _hoisted_16 = { class: "mx-5" }
const _hoisted_17 = { class: "mb-10" }
const _hoisted_18 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_19 = {
  key: 2,
  class: "mb-10"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    id: "closeAddBiModal",
    class: "btn btn-light",
    "data-bs-dismiss": "modal"
  }, " Close "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn-primary"
  }, "Save")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListingTokenValues = _resolveComponent("ListingTokenValues")!

  return (_openBlock(), _createElementBlock("form", {
    class: "form",
    onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          name: "name",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.name) = $event)),
          class: "form-control form-control-solid",
          id: "name"
        }, null, 512), [
          [_vModelText, _ctx.state.name]
        ]),
        (_ctx.v$.name.$error)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.v$.name.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("select", {
          class: "custom-select form-control",
          style: {"border-radius":"5px"},
          id: "inputGroupSelect01",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.tokenTypeId) = $event))
        }, [
          _hoisted_7,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tokensTypes, (tokenType) => {
            return (_openBlock(), _createElementBlock("option", {
              key: tokenType.tokenTypeId,
              value: tokenType.tokenTypeId
            }, _toDisplayString(tokenType.tokenTypeName), 9, _hoisted_8))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.state.tokenTypeId]
        ])
      ]),
      (_ctx.state.tokenTypeId === 7)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                placeholder: "separator ex: ,",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.seperator) = $event))
              }, null, 512), [
                [_vModelText, _ctx.seperator]
              ])
            ]),
            _createElementVNode("small", _hoisted_12, "a" + _toDisplayString(_ctx.seperator) + "b", 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.state.tokenTypeId === 11)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                placeholder: "separator ex: ,",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.seperator) = $event))
              }, null, 512), [
                [_vModelText, _ctx.seperator]
              ])
            ]),
            _createElementVNode("small", _hoisted_16, "a" + _toDisplayString(_ctx.seperator) + "b", 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_17, [
        (_ctx.v$.tokenTypeId.$error)
          ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.v$.tokenTypeId.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ]),
      (
          _ctx.tokensTypes &&
          _ctx.state.tokenTypeId != 0 &&
          (_ctx.tokensTypes.filter((x) => x.tokenTypeId == _ctx.state.tokenTypeId)[0]
            .tokenTypeName == 'Drop down' ||
            _ctx.tokensTypes.filter((x) => x.tokenTypeId == _ctx.state.tokenTypeId)[0]
              .tokenTypeName == 'Multiselect' ||
              _ctx.tokensTypes.filter((x) => x.tokenTypeId == _ctx.state.tokenTypeId)[0]
              .tokenTypeName == 'Multiselect and count')
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createVNode(_component_ListingTokenValues, {
              tokenId: _ctx.tokenId,
              onGetNewValues: _ctx.getNewValues,
              tokenTypeId: _ctx.state.tokenTypeId,
              ref: "tokenList"
            }, null, 8, ["tokenId", "onGetNewValues", "tokenTypeId"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_20
  ], 32))
}